import { render, staticRenderFns } from "./AlertBar.vue?vue&type=template&id=45419b48&scoped=true&"
import script from "./AlertBar.vue?vue&type=script&lang=js&"
export * from "./AlertBar.vue?vue&type=script&lang=js&"
import style0 from "./AlertBar.vue?vue&type=style&index=0&id=45419b48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45419b48",
  null
  
)

export default component.exports